// extracted by mini-css-extract-plugin
module.exports = {"graphPrimary":"#11274a","graphSecondary":"#00b6aa"};